import { render, staticRenderFns } from "./goods-search-bar.vue?vue&type=template&id=75d5daef&scoped=true&"
import script from "./goods-search-bar.vue?vue&type=script&lang=js&"
export * from "./goods-search-bar.vue?vue&type=script&lang=js&"
import style0 from "./goods-search-bar.vue?vue&type=style&index=0&id=75d5daef&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75d5daef",
  null
  
)

export default component.exports